import { App } from './App.js'
import { args } from './args.js'
import { options } from './options.js'

export const command = {
	args,
	options,
	Component: App,
}
